import { type OpenApiSchemaBindingMode, type OpenApiSchemaSimilarCards } from '#shared/api/schema';
import {
    ADDITIONAL_PRODUCTS_MANUAL_MODE,
    ADDITIONAL_PRODUCTS_SOURCE_MODE,
    type AdditionalProductsFormValue,
    type AdditionalProductsManualMode,
} from './constants';

export function getDefaultAdditionalProductsFormValue(): AdditionalProductsFormValue {
    return {
        sourceMode: ADDITIONAL_PRODUCTS_SOURCE_MODE.AI,
        manualMode: ADDITIONAL_PRODUCTS_MANUAL_MODE.ALL,
        binding: {
            productListId: '',
            categoryIds: [],
            collectionIds: [],
        },
    };
}

function mapBindingModeToManualMode(bindingMode: OpenApiSchemaBindingMode): AdditionalProductsManualMode {
    switch (bindingMode) {
        case ADDITIONAL_PRODUCTS_MANUAL_MODE.ALL:
        case ADDITIONAL_PRODUCTS_MANUAL_MODE.SELECTED:
        case ADDITIONAL_PRODUCTS_MANUAL_MODE.CATEGORIES:
            return bindingMode;

        default:
            return ADDITIONAL_PRODUCTS_MANUAL_MODE.ALL;
    }
}

export function mapSettingsToFormState(
    settings: OpenApiSchemaSimilarCards | null | undefined
): AdditionalProductsFormValue {
    if (!settings?.binding_mode) {
        return getDefaultAdditionalProductsFormValue();
    }

    const { binding_mode, binding } = settings;

    return {
        sourceMode: ADDITIONAL_PRODUCTS_SOURCE_MODE.MANUAL,
        manualMode: mapBindingModeToManualMode(binding_mode),
        binding: {
            productListId: binding.product_list_id ?? '',
            categoryIds: binding.category_ids ?? [],
            collectionIds: binding.collection_ids ?? [],
        },
    };
}
